module.exports = __webpack_public_path__ + "img/background_1.0e6f7a41.jpg";